import { useStore } from '@store/StoreEffect';

export const usePermissionCheck = (permission: string) => {
    const { userStore } = useStore();
    return userStore.isAccessablePermission(permission);
};
